import React, { Fragment } from "react";
import classnames from "classnames";
import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";
import _ from "lodash";

import { Tooltip } from "../../../../../components/tooltip/Tooltip";
import { Icon } from "../../../../../components/icon/Icon";
import { useIntlTranslate } from "../../../../../hooks";

import "./CategoryItem.scss";

//TODO: [A11Y] upon WAI-ARIA 1.3 release we should remove 44-48 lines and add aria-description to UnstyledButton component
//aria-label doesn't fit our needs, cuz it reads description first
//aria-describedby requires a custom hidden element

export const CategoryItem = ({
  icon,
  category,
  onClick,
  changeAction,
  disabled,
}) => {
  const { name, description, id, displayName, warning } = category;
  const translate = useIntlTranslate();
  const isChecked = id === "blocked";
  const a11yDescription = translate(`category_${name}.description`);

  return (
    <Fragment>
      <UnstyledButton
        className="categories-item"
        onClick={() => onClick(changeAction, _.castArray(name))}
        role={"checkbox"}
        aria-checked={isChecked}
        aria-describedby={`category-${name}-description`}
        disabled={disabled}
      >
        <div className="categories-item__content">
          <Icon icon={classnames("category-icon fa-regular", icon)} />
          <div>
            {displayName}
            {description ? renderDescription(name, description) : null}
          </div>
        </div>
        {warning ? (
          <div className="categories-item__warning">{warning}</div>
        ) : null}
      </UnstyledButton>
      <div
        className={"sr-only"}
        aria-hidden={true}
        id={`category-${name}-description`}
      >
        {a11yDescription}
      </div>
    </Fragment>
  );
};

const renderDescription = (id, description) => {
  return (
    <Tooltip content={description}>
      <Icon
        data-testid={"category-info"}
        icon="category-info fa-regular fa-info-circle"
      />
    </Tooltip>
  );
};
